import { FC } from 'react';
import FlowWithProvider from './WorkflowEditor';
type WorkflowAdminProps = {

  
};

// const ContactInfo: FC<ContactInfoProps> = ({ contactInfoId, contactInfos, setContactInfos, contactInfosId, setContactInfosId, closeModal, loading, setLoading }) => {
const WorkflowAdmin: FC<WorkflowAdminProps> = () => {
  return (
	<FlowWithProvider></FlowWithProvider>
  );
}

export default WorkflowAdmin;